import { EventTypes, EntityTypes } from 'typings/enums';

interface IPerformanceRatingEventData {
    oldValue: string;
    newValue: string;
}

export interface IPerformanceRatingEvent {
    eventType: EventTypes;
    entityType: EntityTypes;
    employeeSourceId: string;
    data: IPerformanceRatingEventData;
}

export const getPerformanceRatingEvent = (
    employeeSourceId: string,
    oldValue: string,
    newValue: string): IPerformanceRatingEvent => {
    return {
        eventType: EventTypes.UpdatePerformanceRating,
        entityType: EntityTypes.Employee,
        employeeSourceId,
        data: {
            oldValue,
            newValue
        }
    } as IPerformanceRatingEvent;
};